var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersProfiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0254 20.5708L16.0257 17.3571C16.0259 15.5819 14.5869 14.1427 12.8117 14.1427H5.61444C3.83951 14.1427 2.40059 15.5815 2.40039 17.3564L2.40002 20.5708M21.5997 20.571L21.6 17.3572C21.6002 15.5821 20.1612 14.1429 18.386 14.1429M15.4064 4.06061C16.1957 4.64624 16.7072 5.5851 16.7072 6.64343C16.7072 7.70176 16.1957 8.64061 15.4064 9.22625M12.4938 6.64325C12.4938 8.41833 11.0548 9.85731 9.27977 9.85731C7.50469 9.85731 6.06571 8.41833 6.06571 6.64325C6.06571 4.86818 7.50469 3.4292 9.27977 3.4292C11.0548 3.4292 12.4938 4.86818 12.4938 6.64325Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersProfiles);
export default __webpack_public_path__ + "static/media/users-profiles.d4c3614d18ff0222ea5021a587e08f5c.svg";
export { ForwardRef as ReactComponent };